const toIsoDay = (value) => {
  if (!value) return null;
  if (typeof value === 'string') return value.slice(0, 10);
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  return null;
};

// Dates "YYYY-MM-DD" comparées lexicographiquement ; endDate null = gel sans fin.
const isDateInInterestsHold = (date, hold) => {
  const day = toIsoDay(date);
  const start = toIsoDay(hold?.startDate);
  if (!day || !start) return false;
  const end = toIsoDay(hold?.endDate);
  return day >= start && (!end || day <= end);
};

const findInterestsHoldForDate = (date, holds = []) =>
  holds.find((hold) => isDateInInterestsHold(date, hold)) || null;

const getInterestsHoldStatus = (hold, today = new Date()) => {
  const day = toIsoDay(today);
  if (isDateInInterestsHold(day, hold)) return 'active';
  return toIsoDay(hold?.startDate) > day ? 'upcoming' : 'past';
};

const sortInterestsHolds = (holds = []) =>
  [...holds].sort((a, b) => (toIsoDay(b.startDate) || '').localeCompare(toIsoDay(a.startDate) || ''));

const getActiveInterestsHold = (holds = [], today = new Date()) => findInterestsHoldForDate(today, holds);

// Prochain gel dont la date de début est postérieure à aujourd'hui.
const getNextUpcomingInterestsHold = (holds = [], today = new Date()) => {
  const day = toIsoDay(today);
  return holds
    .filter((hold) => toIsoDay(hold?.startDate) > day)
    .sort((a, b) => toIsoDay(a.startDate).localeCompare(toIsoDay(b.startDate)))[0] || null;
};

// monthIndex 0-11 ; un gel impacte le mois s'il chevauche au moins un jour.
const getInterestsHoldsForMonth = (holds = [], year, monthIndex) => {
  if (!year || monthIndex < 0) return [];
  const month = String(monthIndex + 1).padStart(2, '0');
  const lastDay = new Date(Number(year), monthIndex + 1, 0).getDate();
  const monthStart = `${year}-${month}-01`;
  const monthEnd = `${year}-${month}-${String(lastDay).padStart(2, '0')}`;
  return holds.filter((hold) => {
    const start = toIsoDay(hold?.startDate);
    const end = toIsoDay(hold?.endDate);
    return start && start <= monthEnd && (!end || end >= monthStart);
  });
};

// Restreint un gel à la plage [rangeStart, rangeEnd] ; null si aucun chevauchement.
const clipInterestsHoldToRange = (hold, rangeStart, rangeEnd) => {
  const start = toIsoDay(hold?.startDate);
  const end = toIsoDay(hold?.endDate);
  const from = toIsoDay(rangeStart);
  const to = toIsoDay(rangeEnd);
  if (!start || !from || !to) return null;
  const x1 = start > from ? start : from;
  const x2 = !end || end > to ? to : end;
  return x1 <= x2 ? { x1, x2 } : null;
};

// Évite new Date("YYYY-MM-DD") qui est interprété en UTC et peut décaler d'un jour.
const formatHoldDate = (value) => {
  const day = toIsoDay(value);
  if (!day) return '-';
  const [year, month, date] = day.split('-');
  return `${date}/${month}/${year}`;
};

export {
  toIsoDay,
  isDateInInterestsHold,
  findInterestsHoldForDate,
  getActiveInterestsHold,
  getNextUpcomingInterestsHold,
  getInterestsHoldsForMonth,
  clipInterestsHoldToRange,
  getInterestsHoldStatus,
  sortInterestsHolds,
  formatHoldDate,
};
